module.exports = __webpack_public_path__ + "assets/img/404_24h.f7a53aa1.svg";